module.exports = __webpack_public_path__ + "static/media/manage_departments_add_new_department.2e7f66cc.mov";